module.exports = __webpack_public_path__ + "static/media/irakli-dautashvili.47305368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/avatars/irakli-dautashvili.jpg
// module id = 824
// module chunks = 0